import * as React from "react";
import type { SVGProps } from "react";
const SvgPuzzlePiece = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      stroke="#26A3DD"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M6.495 31.985c.01-.16.02-.29.02-.42 0-2.53 0-5.05.02-7.58 0-1.23.06-2.45.07-3.68 0-.64 0-1.28-.01-1.91 0-.5.27-.63.72-.64 2.79-.06 5.58-.14 8.37-.18 1.87-.03 3.74 0 5.61-.03.47 0 .96-.13 1.39-.32.8-.35 1.22-1.19.98-2.04-.22-.76-.56-1.49-.93-2.19-1.58-2.91-.44-6.15 2.78-6.93 3.22-.78 6.03 2.24 5.17 5.47-.22.82-.54 1.61-.82 2.42-.1.29-.24.56-.29.86-.24 1.38.56 2.28 2.01 2.28 3.88 0 7.76-.02 11.64-.03h3.45c.08 0 .16.07.16.15.01.12.02.22.02.31v14.58c0 .21 0 .43.02.64.16 1.25 1.16 1.89 2.36 1.49 1.05-.35 2.07-.78 3.13-1.07 1.85-.51 3.72.24 4.87 1.85 1.06 1.49 1.1 3.61 0 5.12-1.06 1.46-2.91 2.34-5.24 1.59-.69-.22-1.37-.49-2.06-.74-.15-.05-.3-.12-.45-.16-1.52-.46-2.6.33-2.62 1.91-.01 1.37 0 2.74 0 4.11 0 3.6 0 7.19.02 10.79 0 .34-.1.42-.42.42h-14.25c-.82 0-1.4-.5-1.96-.99-.44-.38-.35-.94-.2-1.45.09-.31.87-2.75.86-3.07"
    />
    <path
      stroke="#26A3DD"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M15.155 41.355c.96-.73 1.57-1.53 1.86-2.56.47-1.65.09-3.11-1.08-4.33-1.12-1.17-2.53-1.66-4.13-1.28-.98.23-1.91.65-2.88.93-.48.14-1.02.28-1.49.2-.94-.16-1.03-1.23-.93-2.33M30.865 52.86c.06-.72.05-1.195 0-1.905-.16-2.22-2.16-4.14-4.43-4.11-2.22.04-4.03 1.41-4.46 3.83-.23 1.31.32 2.48.72 3.66.11.32.25.63.38.94.57 1.49-.17 2.67-1.77 2.75-1.14.05-2.28.03-3.42.03H6.455c-.11 0-.21 0-.35-.02-.09 0-.15-.08-.15-.16v-.64c.02-4.34.05-8.69.03-13.03 0-.95.38-1.72.82-2.49.29-.5.84-.66 1.46-.46.78.25 1.54.56 2.32.81 1.66.54 3.04.35 4.56-.71"
    />
  </svg>
);
export default SvgPuzzlePiece;
